"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStockPage = void 0;
const adminUrls = ['/perfil/estoque', '/perfil/adicionar-ao-estoque', '/perfil/buscar-produtos'];
const isStockPage = () => {
    const pathname = window.location.pathname;
    return adminUrls.some((url) => pathname === url);
};
exports.isStockPage = isStockPage;
